import { Box } from "@mui/material";

import iconTimer from "../res/timer.png";

export const Timer = ({ time }) => {
  return (
    <div className="timer">
      <Box component="img" src={iconTimer} width="34px" />
      <span className="digits">
        {("0" + Math.floor((time / 60000) % 60)).slice(-2)}:
      </span>
      <span className="digits">
        {("0" + Math.floor((time / 1000) % 60)).slice(-2)}
      </span>
    </div>
  );
};
